import { useEffect, useState } from 'react';

import { apiGet } from '@/lib/api';
import { formatDate, formatKop } from '@/lib/format';

interface Payout {
  id: string;
  amountKopecks: number;
  method: string;
  periodFrom: string;
  periodTo: string;
  comment: string | null;
  createdAt: string;
  accrualsCount: number;
}

function methodLabel(m: string) {
  if (m === 'cash') return 'Наличка';
  if (m === 'transfer') return 'Перевод';
  return 'Другое';
}

export default function Payouts() {
  const [items, setItems] = useState<Payout[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void apiGet<Payout[]>('/payouts')
      .then((rows) => {
        if (!cancelled) setItems(rows);
      })
      .catch(() => {
        if (!cancelled) setError('Не удалось загрузить выплаты');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div className="text-ink/50 text-sm">Загрузка…</div>;
  if (error) return <div className="card p-4 text-sm text-ink/70">{error}</div>;

  return (
    <div className="max-w-3xl space-y-4">
      <h1 className="text-xl sm:text-2xl font-semibold">Выплаты</h1>
      <p className="text-sm text-ink/55">
        Выплаты фиксирует оператор Resstro после налички или перевода.
      </p>
      {!items.length ? (
        <div className="card p-6 text-ink/55 text-sm">Выплат пока не было</div>
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <div key={p.id} className="card p-4 flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="font-semibold">{formatKop(p.amountKopecks)}</div>
                <div className="text-xs text-ink/50 mt-1">
                  {methodLabel(p.method)} · {p.accrualsCount} начислений
                </div>
                {p.comment ? <div className="text-xs text-ink/45 mt-1">{p.comment}</div> : null}
              </div>
              <div className="text-xs text-ink/45">{formatDate(p.createdAt)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
